import React from 'react'

const MonthlyTick: React.FC<any> = ({ x, y, payload, monthFormat }) => {
  const { value } = payload

  const getNumberOfLetters = () => {
    switch (monthFormat) {
      case 'three':
        return 3
      case 'one':
        return 1
      case 'full':
      default:
        return undefined
    }
  }

  const date = new Date(value)
  const month = new Intl.DateTimeFormat('ru-RU', {
    month: 'long'
  })
    .format(date)
    .slice(0, getNumberOfLetters())

  return (
    <g height={25}>
      <text
        x={x}
        y={y + 6}
        height={25}
        textAnchor={'middle'}
        dominantBaseline="hanging"
        fill="#858FAD"
        fontSize={12}
        fontWeight={400}
        fontFamily="Navigo"
      >
        {month}
      </text>
    </g>
  )
}

export default MonthlyTick
